import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../../api.service';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';

const passwordMatchValidator: ValidatorFn = (group: AbstractControl): ValidationErrors | null => {
    const pass    = group.get('nuevaClave')?.value;
    const confirm = group.get('confirmarClave')?.value;
    return pass === confirm ? null : { mismatch: true };
};

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit {
    resetForm: FormGroup;
    isLoading    = false;
    tokenError   = false;
    successUpdated = false;
    showPassword = false;
    showConfirm  = false;

    private token = '';

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private apiService: ApiService,
        private toastr: ToastrService,
        public themeService: CustomizerSettingsService,
    ) {
        this.resetForm = this.fb.group(
            {
                nuevaClave:    ['', [Validators.required, Validators.minLength(6)]],
                confirmarClave: ['', Validators.required],
            },
            { validators: passwordMatchValidator }
        );
    }

    ngOnInit(): void {
        this.token = this.route.snapshot.queryParamMap.get('token') ?? '';
        if (!this.token) {
            this.tokenError = true;
        }
    }

    onSubmit(): void {
        if (this.resetForm.invalid) {
            this.resetForm.markAllAsTouched();
            return;
        }

        this.isLoading = true;

        this.apiService
            .apiPost('confirmar_clave', false, {
                token:     this.token,
                nuevaClave: this.resetForm.value.nuevaClave,
            }, 2)
            .then(
                (response: any) => {
                    this.isLoading = false;
                    if (response?.data?.success) {
                        this.successUpdated = true;
                    } else {
                        this.tokenError = true;
                        this.toastr.error(
                            response?.data?.message ?? 'Enlace inválido o expirado.',
                            'Error',
                            { timeOut: 4000, positionClass: 'toast-top-center' }
                        );
                    }
                },
                () => {
                    this.isLoading = false;
                    this.toastr.error(
                        'Error de conexión. Intenta de nuevo.',
                        'Error',
                        { timeOut: 4000, positionClass: 'toast-top-center' }
                    );
                }
            );
    }
}
